<template>
  <a-button type="primary" class="btn" @click="push">
    <div style="margin-top: 2px; float: left">
      <iconLight />
    </div>
    <span class="title">{{ title }}</span>
  </a-button>
</template>
<script>
import iconLight from '@/assets/myImg/1/icon-dashboard-white.svg?inline'
export default {
  name: 'WorkButton',
  props: {
    url: {
      type: String,
      default: '/'
    },
    title: {
      type: String,
      default: '工作台'
    }
  },
  components: {
    iconLight
  },
  methods: {
    push() {
      const routeUrl = this.$router.resolve(this.url)
      const shouldOpenInNewTab = this.url.includes('/workbench')
      if (shouldOpenInNewTab) {
        window.open(routeUrl.href, '_blank')
        return
      }
      this.$router.push(this.url)
    }
  }
}
</script>
<style scoped>
.btn {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid #ffffff;
  border-radius: 6px;
  padding: 0 10px;
}
.title {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #ffffff;
  font-weight: 400;
  margin-top: 4px;
  margin-left: 4px;
}
</style>
